import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/theme.css";
import "@/index.css";

const savedTheme = localStorage.getItem("wg_theme");
if (savedTheme) document.documentElement.setAttribute("data-theme", savedTheme);
import App from "@/App";
import { initNativeShell } from "@/lib/native";

initNativeShell();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
